/* eslint-disable import/extensions */
/* eslint-disable @typescript-eslint/quotes */
import React from 'react';
import Image from 'next/image';

import { makeStyles } from '@material-ui/core/styles';
import {
  Box, Button, useMediaQuery, useTheme,
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'next-i18next';
import SocialNetworkIcon from '@/components/ui-components/SocialNetworkIcon';
import Typography from '../../components/Typography';
import Spacer from '@/components/ui-components/Spacer';
import { Profile } from '@/components/ui-components/SVGIcons';

const useStyles = makeStyles((theme) => ({
  root: {},
  profilePicture: {
    borderRadius: 180,
  },
  flexBox: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    padding: 0,
  },
  flexBoxContent: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      alignItems: 'flex-start',
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  linkedInIconLink: {
    marginLeft: theme.spacing(1),
  },
  mobile: {
    [theme.breakpoints.down('md')]: {
      marginRight: theme.spacing(1),
    },
  },
  mobileTitle: {
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(-0.5),
    },
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(0),
    },
  },
  logo: {
    width: '64px',
    height: '64px',
  },
}));

interface Props {
  name: string;
  linkedin?: string;
  title: string;
  background?: string;
  photo?: string;
  onBackgroundOpen: () => void;
  isActive: boolean;
}

const defaultProps = {};

const PersonCard = ({
  name,
  linkedin,
  title,
  background,
  photo,
  onBackgroundOpen,
  isActive,
}: Props) => {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation('markets');
  const md = useMediaQuery(theme.breakpoints.down('md'));
  const desktop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Box className={classes.flexBox}>
      <div className={classes.mobile}>
        {photo
          ? (
            <Image
              src={photo}
              alt={name}
              width={md ? '64px' : '128px'}
              height={md ? '64px' : '128px'}
              className={classes.profilePicture}
            />
          )
          : (
            <Profile size={md ? '64px' : '128px'} />

          )}

      </div>
      <div className={classes.flexBoxContent}>
        <div style={{ minHeight: '29px', display: 'flex' }}>
          <Typography variant="subheader">{name}</Typography>
          {linkedin && (
            <a
              href={linkedin}
              className={classes.linkedInIconLink}
              target="_blank"
              rel="noreferrer"
            >
              <SocialNetworkIcon
                network="linkedin"
                color={theme.palette.primary.main}
              />
            </a>
          )}
        </div>
        <div className={classes.mobileTitle}>
          <Typography variant="base2" align={desktop ? 'center' : 'left'}>
            {title}
          </Typography>
        </div>

        {background && (
          <Button
            onClick={onBackgroundOpen}
            startIcon={isActive ? <CloseIcon /> : <AddIcon />}
            style={{ textTransform: 'none' }}
            color="primary"
          >
            <Typography variant="secondary2bold" color="primary">
              {isActive
                ? t('markets.detailView.team.closeBackground')
                : t('markets.detailView.team.seeBackground')}
            </Typography>
          </Button>
        )}
        {isActive || (md && background) ? (
          <Spacer spacing={3} />
        ) : (
          <Spacer spacing={6} />
        )}
      </div>
    </Box>
  );
};

PersonCard.defaultProps = (defaultProps as unknown) as Partial<Props>;

export default PersonCard;
